var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"orientation-tip"},[_c('p',[_vm._v(_vm._s(this.$t("请使用竖屏以获得最佳体验")))])])}
var staticRenderFns = []

export { render, staticRenderFns }